import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const VerifyingIntegrationPhase = memo(function VerifyingIntegrationPhase({
  disabled,
  progressIcon,
  successIcon,
  errorIcon,
}: VerifyingIntegrationPhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">
          Verifying Okta App Integration...
        </Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1">
          Here we call a few Okta APIs to make sure everything works. Sometimes
          we have to wait a minute or two for Okta to make the app usable.
        </Typography>
      </Box>
    </ServiceConnectionStep>
  );
});

export default VerifyingIntegrationPhase;

// -----------------------------------------------------------------------------

interface VerifyingIntegrationPhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
